module.exports = __webpack_public_path__ + "static/media/engage-flowchart2.021b0d70.jpg";